import { render, staticRenderFns } from "./TaLeftIntroScreen.vue?vue&type=template&id=2a638be0&scoped=true&"
import script from "./TaLeftIntroScreen.vue?vue&type=script&lang=js&"
export * from "./TaLeftIntroScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a638be0",
  null
  
)

export default component.exports